import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["Content", "Icon"]
  static values = { expanded: Boolean }

  connect() {
    this.expanded = this.expandedValue || false
  }

  onToggle(e) {
    e.preventDefault()

    if (this.expanded) {
      this.ContentTarget.classList.add('hidden')
      this.IconTarget.classList.remove("rotate-90", "!text-gray-500")
      this.expanded = false
    } else {
      this.ContentTarget.classList.remove('hidden')
      this.IconTarget.classList.add("rotate-90", "!text-gray-500")
      this.expanded = true
    }
  }
}